// server 端上报在 start-server 处理

if (process.env.AL_EX_FW_MODE && process.browser) {
  // 异步保证时序在 BODY_VISIBLE 后
  // 异步容错，防止异常中断流程
  setTimeout(function () {
    const gaConfig = window.__NEXT_DATA__.runtimeConfig.frameworkConfig.ga
    const IS_ENABLE_REPORT =
      gaConfig.enabled && Math.random() < gaConfig.sampleRate

    /*
     * 加载性能
     */
    {
      const reportLoadPerformance = (eventName, time) => {
        if (IS_ENABLE_REPORT) {
          window.gtag('event', 'timing_complete', {
            name: `awf:load:${eventName}`,
            event_category: window.location.pathname,
            event_label: window.location.pathname + window.location.search,
            value: Math.round(time), // ms 传输，最终 GA 展示时除以1000，展示单位为秒
          })
        }
      }

      // INITIAL        浏览器开始工作 至 开始解析doc head
      // ORIGIN         计时原点，解析 doc head 的时间戳
      // BODY_VISIBLE   内容可见，ORIGIN 至 body 内容可见（css/js 通常未加载完）
      // APP_ACTION     可交互，APP didMount（关键 prefetch 已完成，非关键未完成）
      // APP_READY      完全可交互，非关键 prefetch 也已完成
      // ROUTE_LEAVE      路由离开（页面尚未销毁）
      // ROUTE_ACTION     路由切换后，可交互（prefetch 未完成）
      // ROUTE_READY      路由切换后，完全可交互，非关键 prefetch 也已完成
      // ...

      // 已积累数据转换
      // INITIAL / ORIGIN / BODY_VISIBLE

      const formatMsToS = (ms) => {
        return ms ? `${(ms / 1000).toFixed(2)}s` : '-'
      }

      const origin = window.AL_SPEED_POINT[1][1]
      const initial =
        window.AL_SPEED_POINT[0][1] && Math.round(window.AL_SPEED_POINT[0][1])
      const bodyVisible = window.AL_SPEED_POINT[2][1] - origin
      let appAction
      let appReady
      let routeAction
      let routeReady

      function checkOnAppReady() {
        // 偶见 ready 时序早于 action
        // 统一在此上报，未 ready 就离开的页面丢弃数据。防止数据样本横向失真
        const info = [
          {
            name: 'initial',
            value: initial,
            condition: initial && initial > 500,
            message: '>0.5s',
          },
          {
            name: 'body_visible',
            value: bodyVisible,
            condition: initial && initial + bodyVisible > 800,
            message: 'total>0.8s',
          },
          {
            name: 'app_action',
            value: appAction,
            condition: initial && initial + appAction > 1500,
            message: 'total>1.5s',
          },
          {
            name: 'app_ready',
            value: appReady,
            condition: initial && initial + appReady > 1800,
            message: 'total>1.8s',
          },
        ]
        let hasError = false
        let messageList = []
        info.forEach((item) => {
          if (item.condition) {
            hasError = true
          }
          messageList.push(
            `${item.name}:${formatMsToS(item.value)}${
              item.condition ? `(${item.message})` : ''
            }`
          )
          if (item.value !== undefined) {
            reportLoadPerformance(item.name, item.value)
          }
        })
        console[hasError ? 'error' : 'warn'](
          '[performances]',
          messageList.join(' ')
        )
      }

      function checkOnRouteReady() {
        reportLoadPerformance('route_action', routeAction)
        reportLoadPerformance('route_ready', routeReady)
        {
          const info = [
            {
              name: 'route_action',
              value: routeAction,
              condition: routeAction > 500,
              message: '>0.5s',
            },
            {
              name: 'route_ready',
              value: routeReady,
              condition: routeReady > 1000,
              message: '>1s',
            },
          ]
          let hasError = false
          let messageList = []
          info.forEach((item) => {
            if (item.condition) {
              hasError = true
            }
            messageList.push(
              `${item.name}:${formatMsToS(item.value)}${
                item.condition ? `(${item.message})` : ''
              }`
            )
            if (item.value !== undefined) {
              reportLoadPerformance(item.name, item.value)
            }
          })
          console[hasError ? 'error' : 'warn'](
            '[performances]',
            messageList.join(' ')
          )
        }
      }

      window.AL_REPORT_SPEED_POINT = function (name, time) {
        window.AL_SPEED_POINT.push(arguments)
        switch (name) {
          case 'APP_ACTION':
            if (!appAction) {
              appAction = time - origin
            }
            break
          case 'ROUTE_CHANGE_ARRAY':
            const [_routeLeave, _routeAction, _routeReady] = time
            routeAction = _routeAction - _routeLeave
            routeReady = _routeReady - _routeLeave
            if (!appReady) {
              appReady = _routeReady - origin
              checkOnAppReady()
            }
            checkOnRouteReady()
            break
          default:
            break
        }
      }
      // report 重写前，已填充部分数据。从 APP_ACTION 开始重新 report
      const restPoints = window.AL_SPEED_POINT.splice(3) || []
      restPoints.forEach((point) => {
        window.AL_REPORT_SPEED_POINT(point[0], point[1])
      })
    }

    /*
     * 渲染性能
     */
    {
      const IS_ENABLE_RENDER_REPORT = IS_ENABLE_REPORT && Math.random() < 0.15 // 渲染性能事件较多，额外采样率控制

      const reportRenderPerformance = (eventName, domPath, time) => {
        if (IS_ENABLE_RENDER_REPORT) {
          window.gtag('event', 'timing_complete', {
            name: `awf:render:${eventName}`,
            event_category: window.location.pathname,
            event_label: `${window.location.pathname}|${domPath}`,
            value: Math.round(time), // ms 传输，最终 GA 展示时除以1000，展示单位为秒
            non_interaction: true,
          })
        }
      }

      const getDomPath = (e) => {
        const r = []
        try {
          e.path.every((dom) => {
            if (!dom.tagName || dom.tagName === 'BODY') {
              return false
            }
            r.push(
              dom.tagName +
                (dom.id ? `#${dom.id}` : '') +
                (dom.className ? `.${dom.className}` : '')
            )
            return true
          })
        } catch (err) {
          // no stuff
        }
        if (!r.length) {
          return 'BODY'
        }
        r.reverse()
        return `${r.join('>')}|${e.target && e.target.innerText}`
      }

      const isSupportsPerformance =
        !!window.performance && window.performance.timing
      if (isSupportsPerformance) {
        // 最近发生了 long-task 时，将导致批量的行为延迟，产生无意义上报
        // 提供临时跳过机制，一旦发现 long-task，放行已堆积的尚未触发的事件
        let ignoreCollectViaLongTask

        // 输入延迟性能
        window.addEventListener(
          'ontouchstart' in window ? 'touchstart' : 'click',
          function (e) {
            if (ignoreCollectViaLongTask) {
              return
            }
            const diffTime = window.performance.now() - e.timeStamp
            if (diffTime && diffTime > 100) {
              const domPath = getDomPath(e)
              console.error(
                '[performances]',
                `input_latency: ${Math.round(diffTime)}ms(>100ms)`,
                domPath
              )
              reportRenderPerformance('input_latency', domPath, diffTime)
            }
          },
          true
        )

        // 长任务
        // 仅检查部分，在交互时运行的重任务
        window.addEventListener('click', function (e) {
          if (ignoreCollectViaLongTask) {
            return
          }
          const diffTime = window.performance.now() - e.timeStamp
          if (diffTime && diffTime > 50) {
            // 发现长任务，之后 1s 暂停检测，防止被堆积的任务批量上报
            ignoreCollectViaLongTask = true
            setTimeout(() => {
              ignoreCollectViaLongTask = false
            }, 1000)
            const domPath = getDomPath(e)
            console.error(
              '[performances]',
              `long_task_click: ${Math.round(diffTime)}ms(>50ms)`,
              domPath
            )
            reportRenderPerformance('long_task_click', domPath, diffTime)
          }
        })
      }
    }
  }, 0)
}
